import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { loadComponentTranslations } from '../../funcs/lang-loader';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-features',
  imports: [CommonModule, TranslateModule],
  templateUrl: './features.component.html',
  styleUrl: './features.component.scss',
})
export class FeaturesComponent implements OnInit {
  public features = [
    {
      title: 'Multi Location Scheduling',
      icon: 'fas fa-map-marker-alt',
    },
    {
      title: 'Team Management',
      icon: 'fas fa-users',
    },
    {
      title: 'Appointment Approvals',
      icon: 'fas fa-check-circle',
    },
    {
      title: 'WhatsApp & SMS Reminders',
      icon: 'fas fa-bell',
    },
    {
      title: 'Online Payments',
      icon: 'fas fa-credit-card',
    },
    {
      title: 'Client Management',
      icon: 'fas fa-user-friends',
    },
    {
      title: 'No Show Tracking',
      icon: 'fas fa-user-clock',
    },
    {
      title: 'Custom Booking Pages',
      icon: 'fas fa-calendar-check',
    },
    {
      title: 'Availability & Block Off Time',
      icon: 'fas fa-calendar-alt',
    },
    {
      title: 'Booking Radius Restrictions',
      icon: 'fas fa-map-marked-alt',
    },
    {
      title: 'Email Notifications',
      icon: 'fas fa-envelope',
    },
    {
      title: 'Analytics & Reports',
      icon: 'fas fa-chart-line',
    },
  ];

  constructor(
    private _translateService: TranslateService,
    private _http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  private isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  public ngOnInit(): void {
    let lang = this._translateService.currentLang || 'en';

    this._http
      .get<any>('./assets/i18n/static-content/features.json')
      .subscribe({
        next: (res) => {
          this.features = res[lang]?.['features'];
        },
      });

    loadComponentTranslations(
      this._http,
      this._translateService,
      'controls/features',
      this.isBrowser(),
    ).subscribe({
      next: () => {},
      error: () => {},
    });
  }
}
